<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>bug_report</md-icon>
          </div>
          <h4 class="title">Parents Audit Logs</h4>
        </md-card-header>
        <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-size-50">
                <md-field>
                  <md-input type="text" class="box-textbox" placeholder="Enter email" v-model="parentEmail"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-25">
                  <md-button class="md-primary" :disabled="isDisabled" @click="getParentAuditLogs()">Search</md-button> 
              </div>
          </div>
          <hr>
          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Per page</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Email">{{ item.created_by }}</md-table-cell>
                <md-table-cell md-label="Sub Type" md-sort-by="sub_type">
                  <span :class="statusClass(item.sub_type)">
                    {{ item.sub_type }}
                  </span>
                </md-table-cell>
                <md-table-cell md-label="Message">{{ item.message }}</md-table-cell>
                <md-table-cell md-label="IP Detail">
                  <p v-if="item.ipAddressDetail">{{ item.ipAddressDetail }}</p>
                  <p v-else>-</p>
                </md-table-cell>
                <md-table-cell md-label="Created" md-sort-by="created_at">{{ HumanReadableDateFormat(item.created_at) }}</md-table-cell>                
            </md-table-row>

          </md-table>
          
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class="">
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import Swal from "sweetalert2";
import UsersDataService from "../../services/SuperAdmin/UsersDataService";

export default {
  components: {
    Pagination,
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      currentSort: "orderId",
      currentSortOrder: "asc",
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      tableData: [],
      searchedData: [],
      parentEmail:"",
    };
  },
  methods: {
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    getParentAuditLogs() {
        let data = { parentEmail: this.parentEmail };
        UsersDataService.getParentAuditLogs(data)
          .then((response) => {
            this.tableData = response.data.data;
          })
          .catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
          });
    },
    statusClass(status) {
        switch (status) {
            case "Login":
                return "badge badge-success";
            case "POLICY_APPLY_ERROR":
            case "Too Many Attempts":
            case "Not Managed App":
                return "badge badge-danger";
            case "Google Login":
                return "badge badge-primary";
            default:
                return "";
        }
    },
  },
  beforeMount() {
    this.getParentAuditLogs()
  },
  mounted() {
  },
  watch: {
  },
};
</script>

<style scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
::v-deep .md-table-cell {
  word-wrap: break-word;
  white-space: normal;
  vertical-align: top;
}

::v-deep .md-table-cell[md-label="Email"],
::v-deep .md-table-cell[md-label="Order Status"] {
  min-width: 160px;
}
</style>
